import Vue from 'vue'
import url from '@/services/ApiServices/apiUrls'
import router from '@/router/index'
import { store } from '@/store/store'
import { authenticationApi } from './authenticationApi'
import { vendorApis } from './vendorApis'

export const agentApis = new Vue({
	methods: {
		async agentLogin (userData) {
			if (store.getters['user/isAuthenticated']) {
				await authenticationApi.logOut()
			} else if (store.getters['vendor/isVendorAuthenticated']) {
				await vendorApis.vendorLogOut()
			}
			/* todo : check if any-other user instance is active and log them out  */
			try {
				const agentLoginRes = await this.$http.post(url.agentLoginUrl, userData)
				store.dispatch('agent/setAgentAuthenticated', true)
				router.push({
					name: 'AgentDashBoard'
				})
				return agentLoginRes
			} catch (err) {
				if (err.status === 403 && err.data.message === 'Bad credentials') {
					Vue.toasted.show('Password you entered is wrong')
				} else {
					Vue.toasted.show(`${err.data.message}`)
				}
				//
				// Vue.toasted.show(`${err.data.message}`);
				throw err
			}
		},
		async agentLogOut () {
			/* todo:  clear agent user instance */
			try {
				const res = await this.$http.get(url.agentLogOutUrl)
				store.dispatch('agent/setAgentAuthenticated', false)
				if (router.currentRoute.matched.some(record => record.meta.requiresAgentAuth)) {
					router.push({ name: 'AgentPage' })
				}
				return res
			} catch (err) {
				store.dispatch('agent/setAgentAuthenticated', false)
				throw err
			}
		},
		async getAgentDetails () {
			try {
				const res = await this.$http.get(url.agentInfoUrl)
				return res.data
			} catch (err) {
				throw err
			}
		},
		async updateAgentDetails (agentDetails) {
			try {
				const res = await this.$http.post(url.updateAgentDetailsUrl, agentDetails)
				return res.data
			} catch (err) {
				throw err
			}
		},
		async referVendor (vendorData) {
			try {
				const res = await this.$http.post(url.referVendorUrl, vendorData)
				return res.data
			} catch (err) {
				throw err
			}
		},
		async getReferredVendors () {
			try {
				const res = await this.$http.get(url.referredVendorsUrl)
				return res.data
			} catch (err) {
				throw err
			}
		}
	}
})
